import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
const ModalRegistryContext = createContext(undefined);
export function ModalRegistryProvider({ children }) {
    const [openModalCount, setOpenModalCount] = useState(0);
    const openModal = () => {
        setOpenModalCount(prev => prev + 1);
    };
    const closeModal = () => {
        setOpenModalCount(prev => Math.max(0, prev - 1));
    };
    const isAnyModalOpen = openModalCount > 0;
    return (_jsx(ModalRegistryContext.Provider, { value: { isAnyModalOpen, openModal, closeModal }, children: children }));
}
export function useModalRegistry() {
    const context = useContext(ModalRegistryContext);
    if (!context) {
        throw new Error('useModalRegistry must be used within a ModalRegistryProvider');
    }
    return context;
}
